import {Schema} from 'simpli-web-sdk'
import ConfigNovaSlaComOrigem from '@/model/resource/ConfigNovaSlaComOrigem'

export default (model: ConfigNovaSlaComOrigem): Schema => ({
  ufOrigem: {
    content: model.ufOrigem,
  },
  cidadeOrigem: {
    content: model.cidadeOrigem,
  },
  ufDestino: {
    content: model.ufDestino,
  },
  cidadeDestino: {
    content: model.cidadeDestino,
  },
  sla: {
    content: model.sla || '0',
  },
})
